import { render, staticRenderFns } from "./FamilyView.vue?vue&type=template&id=7746dcb4"
import script from "./FamilyView.vue?vue&type=script&lang=js"
export * from "./FamilyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports